import {
  Button,
  Card,
  Inline,
  Link,
  Stack,
  Typography,
  Viewport,
} from '@omnipresentgroup/design-system';
import type { ReactElement } from 'react';

import { useManagerUser } from '../../../../hooks';
import { WrappedMixpanel } from '../../../../mixpanelWrapper';

export const CARD_TITLE = 'Need a compliant contract?';
export const BUTTON_TEXT = 'View';

const LINK_URL =
  'https://drive.google.com/drive/folders/1h3ullUpsOxAckaUWbT_5fZgMR9CqdJNi';

const CardLayout = ({
  children,
}: {
  children: ReactElement | ReactElement[];
}) => {
  return (
    <Card>
      <Viewport devices={['phone']}>
        <Stack bg="page" p="16">
          {children}
        </Stack>
      </Viewport>
      <Viewport devices={['highRes', 'desktop', 'laptop', 'tablet']}>
        <Inline bg="page" p="16" justify="space-between" align="center">
          {children}
        </Inline>
      </Viewport>
    </Card>
  );
};

export const CompliantContractCard = ({ companyId }: { companyId: string }) => {
  const { userId } = useManagerUser();

  return (
    <CardLayout>
      <Stack gap="8">
        <Typography as="h4" size="16" weight="medium" hideParagraphSpacing>
          {CARD_TITLE}
        </Typography>
      </Stack>
      <Button
        variant="secondary"
        size="small"
        icon="ExternalLink"
        as={Link}
        to={LINK_URL}
        target="_blank"
        onClick={() => {
          WrappedMixpanel.track('Contract View Link Clicked', {
            clientId: companyId,
            userId: userId,
          });
        }}
      >
        {BUTTON_TEXT}
      </Button>
    </CardLayout>
  );
};
